import React, { useState } from "react";

// Listas de fe de una fecha (SOLO LECTURA): los equipos que juegan esa fecha en
// la zona y, al tocar uno, los jugadores a los que se les confirmó la presencia.
//
// La confirmación vive en `date.attendance` (equipoId -> [jugadorId]); el nombre
// y la camiseta salen del roster del torneo (`team.players`), que es lo que llega
// populado del backend. Los jugadores se listan en el orden del roster.
export default function PublicListasFe({ date, teams }) {
  const [equipoAbierto, setEquipoAbierto] = useState(null); // teamId o null

  const getTeam = (id) => teams.find((t) => t.id === id);

  // Los equipos que juegan la fecha salen de los partidos (no de la zona): son
  // los que efectivamente están programados ese día. Sin repetir y por nombre.
  const equiposDeLaFecha = [
    ...new Set(
      (date.matches || []).reduce((ids, m) => {
        if (m.homeTeamId) ids.push(m.homeTeamId);
        if (m.awayTeamId) ids.push(m.awayTeamId);
        return ids;
      }, [])
    ),
  ]
    .map(getTeam)
    .filter(Boolean)
    .sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  // Jugadores confirmados del equipo, en el orden en el que están en el roster.
  const confirmados = (team) => {
    const ids = (date.attendance || {})[team.id] || [];
    return (team.players || []).filter((p) => ids.includes(p.id));
  };

  if (equiposDeLaFecha.length === 0) {
    return (
      <div className="tpub-card">
        <div className="tpub-card-title">Listas de fe</div>
        <p className="tpub-empty tpub-empty--card">No hay equipos programados en esta fecha.</p>
      </div>
    );
  }

  return (
    <div className="tpub-card">
      <div className="tpub-card-title">Listas de fe</div>
      {equiposDeLaFecha.map((team) => {
        const jugadores = confirmados(team);
        const abierto = equipoAbierto === team.id;
        return (
          <div className="tpub-lista" key={team.id}>
            <button
              type="button"
              className={"tpub-lista-head" + (abierto ? " tpub-lista-head--abierta" : "")}
              onClick={() => setEquipoAbierto(abierto ? null : team.id)}
              aria-expanded={abierto}
            >
              <svg
                className="tpub-lista-chevron"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
              <span className="tpub-lista-equipo">{team.name}</span>
              <span className="tpub-lista-cantidad">{jugadores.length}</span>
            </button>

            {abierto && (
              <div className="tpub-lista-body">
                {jugadores.length === 0 ? (
                  <p className="tpub-empty tpub-empty--card">
                    Todavía no hay jugadores confirmados para esta fecha.
                  </p>
                ) : (
                  jugadores.map((p) => (
                    <div className="tpub-lista-jugador" key={p.id}>
                      <span className="tpub-lista-camiseta">{p.camiseta ? "#" + p.camiseta : "—"}</span>
                      <span className="tpub-lista-nombre">{p.name || "Sin nombre"}</span>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
